import React, { useCallback, memo, useContext } from 'react';
import { FuncType } from '../../button/enum';
import { Size } from '../../core/enum';
import Button from '../../button/Button';
import TableContext from '../TableContext';
const CustomizationColumnHeader = function CustomizationColumnHeader(props) {
    const { onHeaderClick } = props;
    const context = useContext(TableContext);
    const openCustomizationModal = useCallback(() => onHeaderClick(context), [context, onHeaderClick]);
    return (React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "predefine", onClick: openCustomizationModal }));
};
CustomizationColumnHeader.displayName = 'CustomizationColumnHeader';
export default memo(CustomizationColumnHeader);
